import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { LINK_TILES_BASE_CLASSNAME } from './Constants';
import { createLinkTiles } from './LinkTiles';
createComponents(".".concat(LINK_TILES_BASE_CLASSNAME), createLinkTiles, NO_PATTERN_BUSINESS_LOGIC);
